import {
    DealerSalesOrderDTO,
    DealerSalesOrderClient_V1,
    DealerSalesOrderSearchDTO,
    AXDocumentDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class SalesOrderService {
    private readonly _dealerSalesOrderClient: DealerSalesOrderClient_V1;

    constructor() {
        this._dealerSalesOrderClient = new DealerSalesOrderClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Orders(dealerAccountUid: string, dto: DealerSalesOrderSearchDTO): Promise<Array<DealerSalesOrderDTO>> {
        return this._dealerSalesOrderClient.getDealerSalesOrders(dto, dealerAccountUid);
    }

    public MSRPOrderReport(dealerAccountUid: string, salesOrderId: string): Promise<AXDocumentDTO> {
        return this._dealerSalesOrderClient.dealerSalesOrderMSRPReport(dealerAccountUid, salesOrderId);
    }
}